import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconArrowRight = ({ classes = null }) => {
    // misc
    const defaultClasses = ['icon-arrow-right'];

    if (classes) {
        defaultClasses.push(classes);
    }

    // render
    return (
        <svg
            className={defaultClasses.join(' ')}
            viewBox='0 0 18 17'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M.5 8.5h15M9.63 1.384l7.07 7.072M9.177 15.82l7.072-7.07'
                fill='none'
                stroke='currentColor'
                strokeLinecap='square' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    classes: PropTypes.string
};

IconArrowRight.propTypes = propTypes;

export { IconArrowRight };

export default IconArrowRight;
